import { render, staticRenderFns } from "./WsEasyTable001.vue?vue&type=template&id=395c62fc"
import script from "./WsEasyTable001.vue?vue&type=script&lang=js"
export * from "./WsEasyTable001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports